module.exports = __webpack_public_path__ + "static/media/logo-internal.b362008a.png";